import { render, staticRenderFns } from "./WelfareReset.vue?vue&type=template&id=7ab53a1a&scoped=true"
import script from "./WelfareReset.vue?vue&type=script&lang=js"
export * from "./WelfareReset.vue?vue&type=script&lang=js"
import style0 from "./WelfareReset.vue?vue&type=style&index=0&id=7ab53a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab53a1a",
  null
  
)

export default component.exports